if (!customElements.get('scrolling-banner')) {
  const ScrollingBanner = class extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
      // Fallback: initLazyScript may not fire if section is already in viewport at page load
      setTimeout(() => this.init(), 100);
    }

    init() {
      if (this._initialized) return;
      this._initialized = true;

      // Load all countdown timers
      customElements.whenDefined('countdown-timer').then(() => {
        this.querySelectorAll('countdown-timer').forEach((el) => el.init());
      });

      // Load all images
      this.querySelectorAll('img[loading="lazy"]').forEach((el) => {
        el.loading = 'eager';
      });

      // After fonts have loaded
      const marqueeEl = this.querySelector('.marquee');
      if (marqueeEl) {
        document.fonts.ready.then(() => marqueeEl.classList.add('marquee--animate'));
        setTimeout(() => marqueeEl.classList.add('marquee--animate'), 1000);
      }
    }
  };

  window.customElements.define('scrolling-banner', ScrollingBanner);
}
